import React, {useState, useRef, useEffect} from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { changeLanguage } from 'actions/langActions';
import { setSearchFormFullScreen } from 'actions/searchFormFullScreenActions';
import {
  Button,
  Grid,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import config from 'config';
import './SiteHeader.css';
import { changeSearchState } from 'actions/searchStateActions';
import { translation } from 'utils/translate';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import {setSearchSubmited} from 'actions/searchSubmitedActions';
import { getFeaturedIcon } from 'utils/commonTools';
//import searchFormFullScreenReducer from 'reducers/searchFormFullScreenReducer';

/* MAIN PAGE HEADER COMPONENT */
const SiteHeader = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const searchState = useSelector((store) => store.searchState);

  const lang = useSelector((store) => store.lang);

  const [searchParams, setSearchParams] = useSearchParams();

  const menuRef = useRef(null);

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  function setOrAppendSearchParams(updates) {
    const newParams = new URLSearchParams(searchParams);

    Object.entries(updates).forEach(([key, value]) => {
      if (newParams.has(key)) {
        newParams.set(key, value); // Replace existing value
      } else {
        newParams.append(key, value); // Add new key
      }
    });

    setSearchParams(newParams);
  }

  const triggerChangeLanguage = (langCode) => {
    toggleMenu()
    setOrAppendSearchParams({lang: langCode})
    // const url = new URL(window.location);
    // url.searchParams.set("lang", langCode);
    // navigate(url.search);
    dispatch(changeLanguage(langCode))
  }

  const handleChange = (event) => {
    dispatch(changeSearchState(event.target.value))
    if (event.target.value === "yleinen"){
      setSearchParams({status: event.target.value})
    }
    else setOrAppendSearchParams({status: event.target.value})
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const setScreen = () => {
    dispatch(setSearchFormFullScreen(false))
  }
  const resetSearchSubmited = () => {
    dispatch(setSearchSubmited(false))
  }

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <Grid container spacing = {0} maxWidth = {1480} 
        sx={{
          margin: 0,
          display: 'flex',
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          boxSizing: 'border-box',
          justifyContent: "space-between"
          }}>
        <Grid item xs={8} sm={6} md={4} lg={4}
          sx={{
            flex: 1,
            textAlign: 'left',
            }}>
          <div
            style={{
              fontSize: '2.8125rem',
              display: 'inlineBlock',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontWeight: 200,
              marginBottom: '-8px',
            }}
          >
            <Link
              to="/#basic-search-term"
              onClick={(setScreen, resetSearchSubmited)}
              style={{
                textDecoration: 'none',
                color: '#313d46',
              }}>
              {config.site.translatedName[lang]}
            </Link>
          </div>
          <div
            style={{
              fontSize: '1rem',
              marginTop: '0.6rem',
              fontWeight: 'normal',
              color: '#313d46',
            }}
          >
            {translation("slogan", lang)}
          </div>
        </Grid>
        {/*Mobile menu*/}
        {/* <Hidden mdUp> */}
        {!isMdUp && (
          <Grid item
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: "flex-end",
              maxWidth: 100
            }}
          >
            <button className="toggler-button" onClick={toggleMenu}>
              <MenuIcon 
                sx={{fontSize: 50}}
              />
            </button>
            {isOpen &&
              <nav ref={menuRef} className={`menu-nav ${isOpen ? 'open' : ''}`}>
                <ul>
                  <Link
                    to="/#basic-search-term"
                    onClick={(toggleMenu, setScreen, resetSearchSubmited)}
                  >
                    <p
                      style={{
                        color: 'white',
                        marginLeft: 20,
                      }}
                    >{translation("home", lang)}</p>
                  </Link>
                  <Link
                    to="/hakuvahti"
                    onClick={toggleMenu}
                  >
                    <p
                      style={{
                        color: 'white',
                        marginLeft: 20,
                      }}
                    >
                      {translation(
                        'hakuvahti',
                        'title',
                        lang,
                      )}
                      {getFeaturedIcon('2026-06-30')}
                    </p>
                  </Link>
                  <Link
                    to="/tietoja"
                    onClick={toggleMenu}
                  >
                    <p
                      style={{
                        color: 'white',
                        marginLeft: 20,
                      }}
                    >{translation("tietoja", lang)}</p>
                  </Link>
                  <Link
                    to="/ohjeet"
                    onClick={toggleMenu}
                  >
                    <p
                      style={{
                        color: 'white',
                        marginLeft: 20,
                      }}
                    >{translation("ohjeet", lang)}</p>
                  </Link>
                  <Link
                    to="/tutkijalle"
                    onClick={toggleMenu}
                  >
                    <p
                      style={{
                        color: 'white',
                        marginLeft: 20,
                      }}
                    >{translation("tutkijalle", lang)}</p>
                  </Link>
                  <Link
                    to="/viittaaminen"
                    onClick={toggleMenu}
                  >
                    <p
                      style={{
                        color: 'white',
                        marginLeft: 20,
                      }}
                    >{translation("viittaaminen", lang)}</p>
                  </Link>
                  <Link
                    to="/palaute"
                    onClick={toggleMenu}
                  >
                    <p
                      style={{
                        color: 'white',
                        marginLeft: 20,
                      }}
                    >
                      {translation('footer', 'palaute', lang)}
                    </p>
                  </Link>
                  <div>
                    <Button onClick={() => triggerChangeLanguage('fi')} 
                      sx={lang === "fi"
                      ? {
                        color: '#2564ec',
                        marginLeft: "20px",
                        textDecoration: 'underline',
                        textDecorationThickness: 3,
                        fontWeight: 'bold',
                        textTransform: 'none',
                        fontSize: 22,
                      }
                      : {
                        color: '#2564ec',
                        marginLeft: "20px",
                        fontWeight: 'bold',
                        textTransform: 'none',
                        fontSize: 22,
                      }}
                    >Suomi</Button>
                  </div>
                  <div>
                    <Button onClick={() => triggerChangeLanguage('se')} 
                      sx={lang === 'se'
                      ? {
                        color: '#2564ec',
                        marginLeft: "20px",
                        textDecoration: 'underline',
                        textDecorationThickness: 3,
                        fontWeight: 'bold',
                        textTransform: 'none',
                        fontSize: 22,
                      }
                      : {
                        color: '#2564ec',
                        marginLeft: "20px",
                        fontWeight: 'bold',
                        textTransform: 'none',
                        fontSize: 22,
                      }}
                    >Svenska</Button>
                  </div>
                  <p
                    style={{
                      paddingLeft: 20,
                      fontWeight: 700,
                      fontSize: 20,
                    }}
                  >{translation("hakutila",lang)} </p>
                  <div
                    style={{
                      border: '1.5px solid black',
                      background: 'var(--text-color-light)',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderRadius: '4px',
                      marginLeft: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <FormControl component="fieldset">
                      <RadioGroup aria-label="searchMode" name="searchMode1" value={searchState} onClick={toggleMenu} onChange={(event) => handleChange(event)}>
                        <FormControlLabel
                          value="yleinen"
                          control={<Radio color = 'secondary' size="small" 
                            sx = {{ paddingLeft: "20px"}}
                            />} 
                          label = {<Typography 
                              sx={{
                                fontWeight: 'bold',
                                fontSize: 18,
                              }}
                            >{translation("yleinen", lang)}</Typography> }
                        />
                        <FormControlLabel
                          value="tutkija"
                          control={<Radio color = "secondary" size="small" 
                            sx= {{paddingLeft: "20px"}}
                            />} 
                          label={<Typography 
                            sx = {{
                                fontWeight: 'bold',
                                fontSize: 18,
                              }}
                            >{translation("tutkija", lang)}</Typography> }
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </ul>
              </nav>
            }
          </Grid>
        )}
        {/* </Hidden> */}

        {/* <Hidden smDown> */}
        {isMdUp && (
          <>
          <Grid item md={4} lg={4} 
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: "right",
                textTransform: 'none',
              }}
            >
            <Button onClick={() => triggerChangeLanguage('fi')} 
                sx={{
                  color: '#2564ec',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  marginRight: '20px',
                  textDecoration:  lang === "fi"? 'underline':'none', 
                  textDecorationThickness: lang === "fi" ? 3: 0,
                }}
              >
                Suomi
              </Button>
            <Button  onClick={() => triggerChangeLanguage('se')}
                sx={{
                  color: '#2564ec',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  marginRight: '20px',
                  textDecoration:  lang === "se"? 'underline':'none', 
                  textDecorationThickness: lang === "se" ? 3: 0,
                }}
              >
                Svenska
              </Button>
            </Grid>
          <Grid item md={4} lg={4} 
              sx={{
                fontSize: '14px',
                display: "flex",
                justifyContent: "right",
                marginTop: "1%",
                marginBottom: "1%",
              }}>
            <Grid container sx={{ maxWidth: 410 }}>
              <Grid item xs={12} sm={12} md={12} lg={12} 
                  sx={{
                    border: '1.5px solid gray',
                    background: 'rgba(211,211,211,0.3)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: '4px',
                }}>
                  <p
                    style={{
                      paddingLeft: 5,
                      margin: 10,
                      fontWeight: 'bold',
                    }}
                  >
                {translation("hakutila",lang)} </p>
                  <FormControl component="fieldset">
                  <RadioGroup row aria-label="searchMode" name="searchMode1" value={searchState} onChange={(event) => handleChange(event)}>
                      <FormControlLabel
                        value="yleinen"
                        control={
                          <Radio
                          color = 'primary' 
                            size="small"
                            sx={{ pl: '1px' }} // pl = padding-left: theme.spacing(1) = 8px by default/>}
                          />
                        }
                      label = {
                        <Typography sx = {{fontWeight: 'bold',fontSize: '14px'}}>
                          {translation("yleinen", lang)}
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="tutkija"
                        control={
                          <Radio
                          color = "primary" 
                            size="small"
                            sx={{ pl: '1px' }}
                          />
                        }
                        label={
                        <Typography sx = {{fontWeight: 'bold',fontSize: '14px'}}>
                          {translation("tutkija", lang)}
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        {/* </Hidden> */}
      </Grid>

      {/* <Hidden smDown> */}
      {isMdUp && (
        <Grid container 
          sx={{
            borderTop: '1.5px solid var(--gray-verylight)',
            borderBottom: '1.5px solid var(--gray-verylight)',
            marginTop: "16px",
            marginBottom: "16px",
            justifyContent: "center",
          }}
        >
          <Grid
            item
            md={12}
            lg={12}
            gap={'30px'}
            sx = {{
              verticalAlign: 'top',
              display: 'flex',
              justifyContent: 'center',
              top: 0,
              fontSize: '1rem',
            }}
          >
            <Link
              to="/#basic-search-term"
              className={
                location.pathname === '/' ? 'selected' : ''
              }
              onClick={(setScreen, resetSearchSubmited)}
            >
              <p style={{ color: 'black' }}>
                {translation("home", lang)}
              </p>
            </Link>
            
            <Link
              to="/hakuvahti"
              className={
                location.pathname === '/hakuvahti'
                  ? 'selected'
                  : ''
              }
            >
              <p
                style={{
                  color: 'black',
                }}
              >
                {translation('hakuvahti', 'title', lang)}
                {getFeaturedIcon('2026-06-30')}
              </p>
            </Link>
          
            <Link
              to="/tietoja"
              className={
                location.pathname === '/tietoja'
                  ? 'selected'
                  : ''
              }
            >
              <p style={{ color: 'black' }}>
                {translation("tietoja", lang)}
              </p>
            </Link>
            <Link
              to="/ohjeet"
              className={
                location.pathname === '/ohjeet'
                  ? 'selected'
                  : ''
              }
            >
              <p style={{ color: 'black' }}>
                {translation("ohjeet", lang)}
              </p>
            </Link>
            <Link
              to="/tutkijalle"
              className={
                location.pathname === '/tutkijalle'
                  ? 'selected'
                  : ''
              }
            >
              <p style={{ color: 'black' }}>
                {translation("tutkijalle", lang)}
              </p>
            </Link>
            <Link
              to="/viittaaminen"
              className={
                location.pathname === '/viittaaminen'
                  ? 'selected'
                  : ''
              }
            >
              <p style={{ color: 'black' }}>
                {translation('viittaaminen', lang)}
              </p>
            </Link>
            <Link
              to="/palaute"
              className={
                location.pathname === '/palaute'
                  ? 'selected'
                  : ''
              }
            >
              <p style={{ color: 'black' }}>
                {translation('footer', 'palaute', lang)}
              </p>
            </Link>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default SiteHeader;
